import { Component, OnInit, OnDestroy, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { VideoStreamService } from '../services/video-stream.service';
import { VideoFeed } from '../../models/video-feed.model';
import { Subscription } from 'rxjs';
import { Utility } from '../utils/app-utils';
import { AlarmService } from '../services/alarm.service';
import { ConfidenceMonitoringService } from '../services/confidence-monitoring.service';
import { MatDialog } from '@angular/material/dialog';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { AuthenticationService } from '../services/authentication.service';
import { ApiConstants } from '../constants/api-constants';

@Component({
	selector: 'app-video-feeds',
	templateUrl: './video-feeds.component.html',
	styleUrls: ['./video-feeds.component.scss']
})
export class VideoFeedsComponent implements OnInit, OnDestroy, OnChanges {
	private videoSourceChangedSub: Subscription;
	private zoneVideoSourceChangedSub: Subscription;
	// Flag used to detect whether user viewing alarm from other branch than last selected.
	public lastBranchId = null;
	public branchId = null;
	selectedAlarm: any;
	public lastselectedAlarmId = null;
	lastZoneId = null;
	sitesChangedSubscriber: Subscription;
	@Output() videoSourceChange = new EventEmitter();
	utility = Utility;
	windowVideos = [0, 1];
	alarmsExist: boolean = false;
	readonly streamAppToken = ApiConstants.STREAM_APP_TOKEN;

	get streamEngineServerUrl(): string {
		return this.authenticationService.getUser()?.streamServerIP || '';
	}

	constructor(public videoStreamService: VideoStreamService, public alarmService: AlarmService,
		public confidenceMonitoringService: ConfidenceMonitoringService, public dialog: MatDialog,
		private dashboardComponent: DashboardComponent,
		private authenticationService: AuthenticationService) { }

	async ngOnChanges() {
	}

	ngOnInit() {
		this.videoStreamService.setToken();
		this.zoneVideoSourceChangedSub = this.videoStreamService.videoSourceZoneNotification().subscribe(async (sources) => {
			this.selectedAlarm = this.alarmService.selectedAlarm;
			if (this.selectedAlarm) {
				this.lastselectedAlarmId = this.selectedAlarm.id;
			};
			this.lastBranchId = null;
			if (sources) {
				if (this.lastZoneId !== (this.selectedAlarm?.sensor?.zone?._id || this.selectedAlarm?.zone?.id)) {
					await this.videoStreamService.setEmptyVideoSources();
					this.lastZoneId = this.selectedAlarm?.sensor?.zone?._id || this.selectedAlarm?.zone?.id;
					await this.loadVideoFeeds_zones(sources);
					this.videoSourceChange.emit();
					this.windowVideos = [0, 1];
				}
			} else {
				this.lastZoneId = null;
				this.videoSourceChange.emit();
				await this.videoStreamService.setEmptyVideoSources();
			}
		});

		// called when site is selected in Confidence Monitoring mode
		this.sitesChangedSubscriber = this.confidenceMonitoringService.getSitesChangedNotification().subscribe(async (branch: any) => {
			this.windowVideos = [0, 1];
			this.lastBranchId = null;
			this.lastZoneId = null;
		});

		this.ChangeVideoSource();
	}

	ChangeVideoSource() {
		this.videoSourceChangedSub = this.videoStreamService.videoSourceBranchNotification().subscribe(async (branchId) => {
			if (this.alarmService.alarmList) {
				this.alarmService.alarmList.length > 0 ? this.alarmsExist = true : this.alarmsExist = false;
			};

			this.selectedAlarm = this.alarmService.selectedAlarm;
			if (this.selectedAlarm) {
				// update lastselectedAlarmId
				this.lastselectedAlarmId = this.selectedAlarm.id;
			};

			this.lastZoneId = null;
			if (branchId && this.alarmsExist) {
				if (this.lastBranchId !== branchId) {
					await this.videoStreamService.setEmptyVideoSources();
					this.lastBranchId = branchId;
					this.loadVideoFeeds(branchId);
					this.videoSourceChange.emit();
					this.windowVideos = [0, 1];
				}
			} else {
				this.lastBranchId = null;
				this.lastZoneId = null;
				this.videoSourceChange.emit();
			}
		});
	}

	ngOnDestroy() {
		this.videoSourceChangedSub.unsubscribe();
		this.zoneVideoSourceChangedSub.unsubscribe();
		this.videoStreamService.setEmptyVideoSources();
		this.sitesChangedSubscriber.unsubscribe();
	}

	async loadVideoFeeds(branchId: string) {
		await this.videoStreamService.fetchVideoSourcesList(branchId);
	}

	async loadVideoFeeds_zones(sources: any) {
		await this.videoStreamService.fetchVideoSourcesList_zones(sources);
	}

	async shareVideo(windoNo: number) {
		let alarmType = this.selectedAlarm.type;
		if (windoNo === 0) {
			await this.videoStreamService.shareVideo(this.videoStreamService.sourceOneName, alarmType);
		} else if (windoNo === 1) {
			await this.videoStreamService.shareVideo(this.videoStreamService.sourceTwoName, alarmType);
		}
	}

	async unShareVideo() {
		await this.videoStreamService.unShareVideo();
	}

	async controlVideo(windoNo: number, videoFeed: any) {
		if (windoNo === 0) {
			let response = await this.videoStreamService.controlVideo(this.videoStreamService.sourceOneIp);
			if (response.success === true) {
				const vncData: any = {
					url: [response.data.url],
					invalidUrl: false
				};
				this.showFullScreenVideo(vncData);
			}
		} else if (windoNo === 1) {
			let response = await this.videoStreamService.controlVideo(this.videoStreamService.sourceTwoIp);
			if (response.success === true) {
				const vncData: any = {
					url: [response.data.url],
					invalidUrl: false
				};
				this.showFullScreenVideo(vncData);
			}
		}
	}

	showFullScreenVideo(videoFeed: VideoFeed) {
		this.dashboardComponent.showOverlayWidget('fullscreen-video', videoFeed);
	}

	asSourceUrl(url: string | string[]): string {
		return Array.isArray(url) ? (url[0] || '') : (url || '');
	}

}
